export enum ThemeColors {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  WARNING_BRAND = 'warning-brand',
  DANGER = 'danger',
  SKY = 'sky',
  LAVENDER = 'lavender',
}
